import { render, staticRenderFns } from "./RegularListBuyBox.vue?vue&type=template&id=363f4a43&scoped=true"
import script from "./RegularListBuyBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegularListBuyBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegularListBuyBox.vue?vue&type=style&index=0&id=363f4a43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f4a43",
  null
  
)

export default component.exports